export default __webpack_public_path__ + "217e90fb5a57606f9ce642783120afe7.svg";